import { useEffect, useMemo } from 'react';
import { fetchAgencyLinks } from '@rsos/reduxDataStore/src/features/peerAgencies/peerAgenciesSlice';
import isAgencyShareChatEnabled from '@rsos/utils/isAgencyShareChatEnabled';
import { useAppDispatch, useAppSelector } from '@rsos/utils/reduxHooks';

const useFetchAgencyLinks = () => {
  const dispatch = useAppDispatch();

  const psaps = useAppSelector(state => state.psaps);

  const sinatra = useAppSelector(state => state.sinatra);

  const currentOrgName = sinatra.user.currentOrg.name;

  const hasAgencyShareChatAccess = useMemo(
    () => isAgencyShareChatEnabled(psaps),
    [psaps],
  );

  useEffect(() => {
    if (currentOrgName && hasAgencyShareChatAccess)
      dispatch(fetchAgencyLinks(currentOrgName));
  }, [currentOrgName, dispatch, hasAgencyShareChatAccess]);
};

export default useFetchAgencyLinks;
